import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const deleteJointNominee: (
  fetchContext: FetchContext,
  nominationId: number,
  jointNomineeId: number,
  accessToken?: string,
) => Promise<void> = (fetchContext, nominationId, jointNomineeId, accessToken) =>
  fetch(`${fetchContext.baseUrl}/api/nominations/${nominationId}/joint-nominees/${jointNomineeId}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'delete joint nominee'));
